import { fromPromise } from '@apollo/client';
import { refreshTokenSynchronized } from './synchronizedRefreshToken';
import WindowWrapper from '../../../utils/windowWrapper';

const ANOTHERDEVICE_ERROR_REASON = 'ANOTHERDEVICE';
const JWTEXPIRED_ERROR_REASON = 'JWTEXPIRED';

const sessionEndedUrl = '/session-ended';
const anotherReasonUrl = `${sessionEndedUrl}?reason=ANOTHERDEVICE`;

export const handleUnauthenticatedError = (error, context) => {
  const processor = errorReasonProccessors.find(processor => processor.reason === error.result);

  if (processor) {
    return processor.handle(context);
  }

  WindowWrapper.setLocation(sessionEndedUrl);
};

const handlerAnotherDeviceError = () => WindowWrapper.setLocation(anotherReasonUrl);

const handlerJwtExpiredError = context => {
  const { client, subscriber, forward } = context;

  return fromPromise(refreshTokenSynchronized(client))
    .flatMap(() => forward())
    .subscribe(subscriber);
};

const errorReasonProccessors = [
  {
    reason: ANOTHERDEVICE_ERROR_REASON,
    handle: handlerAnotherDeviceError
  },
  {
    reason: JWTEXPIRED_ERROR_REASON,
    handle: handlerJwtExpiredError
  }
];
